import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Particles that stay lowercase unless they open the name.
// Covers French (de, du, des, le, la), Dutch/Flemish (van, den, der, ten, ter),
// and German (von). Elided forms (d', l') are handled separately below.
const NAME_PARTICLES = new Set([
  "de", "du", "des", "le", "la", "les",
  "van", "den", "der", "ten", "ter",
  "von",
]);

export function toTitleCase(str) {
  if (!str || typeof str !== "string") return str;
  return str
    .trim()
    .split(/\s+/)
    .map((word, i) => {
      const lower = word.toLowerCase();
      // Elided particle: d'Alembert, l'Estrange — lowercase particle, cap after apostrophe.
      const aposIdx = lower.indexOf("'");
      if (aposIdx !== -1) {
        const pre = lower.slice(0, aposIdx);
        const post = lower.slice(aposIdx + 1);
        const isElided = pre === "d" || pre === "l";
        if (i > 0 && isElided)
          return pre + "'" + post.charAt(0).toUpperCase() + post.slice(1);
        return (
          pre.charAt(0).toUpperCase() +
          pre.slice(1) +
          "'" +
          post.charAt(0).toUpperCase() +
          post.slice(1)
        );
      }
      // Hyphenated compound: Marie-Claire → each segment capitalised.
      if (lower.includes("-"))
        return lower
          .split("-")
          .map((seg) => seg.charAt(0).toUpperCase() + seg.slice(1))
          .join("-");
      // Particle: lowercase unless it is the very first word.
      if (i > 0 && NAME_PARTICLES.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}
